import { render, staticRenderFns } from "./MachineAlerts.vue?vue&type=template&id=3db45c6e&"
import script from "./MachineAlerts.vue?vue&type=script&lang=js&"
export * from "./MachineAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports